import { Button, Stack, Typography } from "@mui/material";
import { RedirectKeys } from "../auth/authTypes";
import AuthenticationFailedIcon from "../icons/AuthenticationFailedIcon";
import InfoPage from "./infoPage/InfoPage";

interface Props {
  errorDetails?: string;
  buttonText?: string;
  redirectPath?: string;
}

const AuthenticationFailed = ({ errorDetails, buttonText, redirectPath }: Props) => {
  return (
    <InfoPage
      Icon={<AuthenticationFailedIcon />}
      title="Authentication Failed"
      subtitle={
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          {errorDetails && (
            <Typography variant="subtitle1" color="error">
              {errorDetails}
            </Typography>
          )}
          <Typography color="textSecondary">
            There is a problem with your authentication to the portal. Please check login and password and try again, if
            the error appears again please contact support.
          </Typography>
        </Stack>
      }
    >
      <Button href={redirectPath || `/?${RedirectKeys.Prompt}=select_account`} color="primary" variant="contained">
        {buttonText || "Sign In with another account"}
      </Button>
    </InfoPage>
  );
};

export default AuthenticationFailed;
